import { useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { ExpandMoreIcon } from "@dotnet/telematics-design-system";

import TextLink, {
    TEXT_LINK_SIZES
} from "components/DesignComponents/TextLink";

import { ShowMoreProps } from "../types";
import Loader from "./Loader";

const ShowMore = ({ onClick }: ShowMoreProps) => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(false);

    const handleClick = () => {
        setIsLoading(true);
        onClick(true);
    };

    return (
        <div css={css({ display: "flex", padding: "8px 0 20px 0" })}>
            {isLoading ? (
                <Loader />
            ) : (
                <TextLink size={TEXT_LINK_SIZES.Small} onClick={handleClick}>
                    {t("Button##show more")}
                    <ExpandMoreIcon />
                </TextLink>
            )}
        </div>
    );
};

export default ShowMore;
